export const testAttributes = {
    AUTHOR_TOOLTIP_MAIN_CONTAINER: 'author_tooltip_main_container',
    AUTHOR_TOOLTIP_CONTENT_CONTAINER: 'author_tooltip_content_container',
    AUTHOR_TOOLTIP_AVATAR: 'author_tooltip_avatar',
    AUTHOR_TOOLTIP_AVATAR_IMAGE: 'author_tooltip_avatar_image',
    AUTHOR_TOOLTIP_BIOGRAPHY: 'author_tooltip_biography',
    AUTHOR_TOOLTIP_NAME: 'author_tooltip_name',
    AUTHOR_TOOLTIP_SOCIAL: 'author_tooltip_social',
};

export const ariaLabels = {
    FULL_BIO_LINK: 'view full biography page'
};